import React from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Stack,
  Chip
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const ArticleCard = ({ guide }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 3,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        maxWidth: "250px"
      }}
    >
      <CardActionArea
        onClick={() => navigate(guide.path)}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          height: "100%"
        }}
      >
        <CardMedia
          component={guide.image ? "img" : "div"}
          image={guide.image || undefined}
          alt={guide.title}
          sx={{
            height: 120,
            width: "100%",
            bgcolor: guide.image ? "transparent" : theme.palette.secondary.main,
            objectFit: guide.image ? "cover" : "none"
          }}
        />
        <CardContent sx={{ flexGrow: 1 }}>
          <Typography
            variant="h6"
            fontWeight={600}
            gutterBottom
            sx={{ color: theme.palette.cardHeader.main }}
          >
            {guide.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {guide.description}
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" mt={1} useFlexGap
            sx={{
              flexWrap: "wrap",
              rowGap: 1.5,
              columnGap: 1,
            }}>
            {(guide.tags || []).map((tag) => (
              <Chip key={tag} label={tag} size="small" onClick={() => { }} />
            ))}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ArticleCard;
